import React from 'react'
import PropTypes from 'prop-types'
import ContentBoxWithoutHeader from '../../../layout/component/ContentBoxWithoutHeader'
import TransitionList from './TransitionList'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TRANSITION_LIST_WIDGET_CONTAINER } from '../../ui-definition/process-ui'

const STYLE = {
    padding: '15px',
    textAlign: 'left',
}

const STYLE_VALIDATION = {
    paddingTop: '15px',
}

const TransitionListWidget = ({ taskReadOnly, task, availableTransitionList, validateAndTriggerEvent, validationMessageList }) => {
    if (!currentUserHasAccess(TRANSITION_LIST_WIDGET_CONTAINER)) {
        return null
    }

    if (taskReadOnly || task.status === 'skipped' || task.status === 'finished') {
        return null
    }
    return (
        <ContentBoxWithoutHeader>
            <div style={STYLE}>
                <div>
                    <TransitionList
                        taskReadOnly={taskReadOnly}
                        task={task}
                        availableTransitionList={availableTransitionList}
                        validateAndTriggerEvent={validateAndTriggerEvent}
                    />
                </div>
                {!!validationMessageList.length && (<div style={STYLE_VALIDATION}>
                    <ValidationMessageList
                        validationMessageList={validationMessageList}
                    />
                </div>)}

            </div>

        </ContentBoxWithoutHeader>
    )
}


TransitionListWidget.propTypes = {
    taskReadOnly: PropTypes.bool.isRequired,
    task: PropTypes.object.isRequired,
    availableTransitionList: PropTypes.array.isRequired,
    validateAndTriggerEvent: PropTypes.func.isRequired,
}

export default TransitionListWidget



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/TransitionListWidget.js